import { generatePath, Navigate, RouteObject, useLocation, useParams } from "react-router-dom";

const Redirect = (props: { path: string }) => {
  const location = useLocation();
  const params = useParams();
  const resolvedPath = generatePath(props.path, params);
  return <Navigate to={{ pathname: resolvedPath, search: location.search }} replace />;
};

const redirects: RouteObject[] = [
  // Handle redirecting users who may have bookmarked legacy login page route
  // Login flow now starts with auth0 always
  { path: "login", element: <Redirect path="/" /> },
  {
    path: "workbench/*",
    element: <Redirect path="/workbenches/*" />,
  },
  {
    path: "workbenches/:projectId/catalog/datasets",
    element: <Redirect path="/data-browser/tables" />,
  },
  {
    path: "workbenches/:projectId/catalog/datasets/:tableFQN",
    element: <Redirect path="/data-browser/tables/:tableFQN" />,
  },
  {
    path: "workbenches/:projectId/catalog/variables",
    element: <Redirect path="/data-browser/columns" />,
  },
  {
    path: "workbenches/:projectId/catalog/tables",
    element: <Redirect path="/data-browser/tables" />,
  },
  {
    path: "workbenches/:projectId/catalog/tables/:tableFQN",
    element: <Redirect path="/data-browser/tables/:tableFQN" />,
  },
  {
    path: "workbenches/:projectId/catalog/columns",
    element: <Redirect path="/data-browser/columns" />,
  },
  {
    path: "workbenches/:projectId/environment/:envId",
    element: <Redirect path="/workbenches/:projectId/environments/:envId" />,
  },
  // Redirect old catalog routes to data-browser
  {
    path: "catalog",
    element: <Redirect path="/data-browser/tables" />,
  },
  {
    path: "catalog/datasets",
    element: <Redirect path="/data-browser/tables" />,
  },
  {
    path: "catalog/datasets/:tableFQN",
    element: <Redirect path="/data-browser/tables/:tableFQN" />,
  },
  {
    path: "catalog/tables",
    element: <Redirect path="/data-browser/tables" />,
  },
  {
    path: "catalog/tables/:tableFQN",
    element: <Redirect path="/data-browser/tables/:tableFQN" />,
  },
  {
    path: "catalog/variables",
    element: <Redirect path="/data-browser/columns" />,
  },
  {
    path: "catalog/columns",
    element: <Redirect path="/data-browser/columns" />,
  },
  {
    path: "catalog/pins",
    element: <Redirect path="/data-browser/pins" />,
  },
  // Redirect old catalog concepts routes to data-browser dashboards
  {
    path: "catalog/concepts/search",
    element: <Redirect path="/data-browser/dashboards/concepts/search" />,
  },
  {
    path: "catalog/concepts/:groupId",
    element: <Redirect path="/data-browser/dashboards/concepts/:groupId" />,
  },
  {
    path: "catalog/concepts/:conceptId/details",
    element: <Redirect path="/data-browser/dashboards/concepts/:conceptId/details" />,
  },
  { path: "data-dashboard", element: <Redirect path="/data-overview" /> },
  // Redirect old reports routes to new dashboards routes under data-browser
  { path: "data-browser/reports", element: <Redirect path="/data-browser/dashboards" /> },
  {
    path: "reports/:reportType",
    element: <Redirect path="/data-browser/dashboards/:reportType" />,
  },
  { path: "projects", element: <Redirect path="/workbenches" /> },
  { path: "projects/*", element: <Redirect path="/workbenches/*" /> },
  {
    path: "projects/:id/files/project",
    element: <Redirect path="/workbenches/:id/files/workbench" />,
  },
  {
    path: "projects/:id/files/project/*",
    element: <Redirect path="/workbenches/:id/files/workbench/*?" />,
  },
  // Project level catalog view moved to data-browser
  {
    path: "projects/:id/catalog/*",
    element: <Redirect path="/data-browser/tables" />,
  },
  {
    path: "files/projects",
    element: <Redirect path="/files/workbenches" />,
  },
  {
    path: "files/projects/*",
    element: <Redirect path="/files/workbenches/*?" />,
  },
  // Redirect old global files route to new data-browser files route
  { path: "files", element: <Redirect path="/data-browser/files" /> },
  { path: "files/*", element: <Redirect path="/data-browser/files/*?" /> },
  // Admin conversation view moved to shared route
  {
    path: "admin/conversations/:conversationId",
    element: <Redirect path="/shared/conversations/:conversationId" />,
  },
];

export default redirects;
